import PropTypes from 'prop-types'
import React, { useEffect } from "react"

import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { Field, Form } from '@availity/form'
import '@availity/yup'
import * as yup from 'yup'

import { Auth } from 'aws-amplify'

// actions
import { loginUser, apiError } from "store/actions"

// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"


const Login = props => {
const { error} = props

  // Error state survives in the store, so a failure from an earlier visit would
  // still be on screen when this page is reopened. Clear it on mount.
  useEffect(() => {
    props.apiError("")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handleValidSubmit
  const handleValidSubmit = (values, event) => { 
     console.log(values)
    props.loginUser(values, props.history)
  }

  const signInWithGoogle = () => {
    Auth.federatedSignIn({ provider: 'Google' })
  }

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div style={{backgroundColor:"#738276"}}>
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 style={{textColor:"#384E3E"}}>Welcome Back!</h5>
                        <h6 style={{textColor: "#384E3E"}}>Sign in to Sage.</h6>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={handleValidSubmit}
                      initialValues={{  
			  username: '',
			  password: '',
		      }}
	              validationSchema={yup.object().shape({
			 username: yup
			    .string()
			    .isRequired(true, 'Username is required'),
			 password: yup
			    .string()
			    .isRequired(true, 'Password is required'),
		      })}
                    >
                      {error && error != "" ? (
                        <Alert color="danger">{error}</Alert>
                      ) : null}

                      <div className="form-group">
                        <Field
                          name="username"
                          label="Username"
                          type="text"
                        />
                      </div>

                      <div className="form-group">
                        <Field
                          name="password"
                          label="Password"
                          type="password"
                        />
                      </div>

                      <div className="mt-3">
                        <button
	                className="btn btn-success btn-block waves-effect waves-light"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock mr-1" />
                          Forgot your password?
                        </Link>
                      </div>

                      <div className="mt-3">
                        <button
                          className="btn btn-outline-dark btn-block waves-effect waves-light d-flex align-items-center justify-content-center"
                          type="button"
                          onClick={signInWithGoogle}
                        >
                          <i className="mdi mdi-google mr-2" style={{ fontSize: "1.1rem" }} />
                          Sign in with Google
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
	      <div>
                <p>
                  © {new Date().getFullYear()} Permaculture Gardens. 
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  if (state.Login.error!="") {
      return { error: state.Login.error.message }
  } 
  return { error: state.Login.error }
}

export default connect(
  mapStateToProps,{ loginUser, apiError }
)(withRouter(Login))

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  apiError: PropTypes.func,
}
